/* =====================================================================
   PADDENSTOEL-KEUZEHULP · INSTELLINGEN
   ---------------------------------------------------------------------
   Dit is het enige bestand dat je hoeft aan te passen.

   1. PRODUCTEN   → koppel elk product aan de Shopify-handle(s).
                    De handle is het laatste stuk van de productlink:
                    jouwshop.nl/products/lions-mane-drops → "lions-mane-drops"
                    Naam, foto, prijs, voorraad en link komen automatisch
                    uit Shopify. Klopt een handle niet, dan valt de tool
                    terug op een andere vorm of een zoeklink.
   2. FLOW        → de vragen, antwoorden en welk product bij welk
                    antwoord hoort (product, alternatief, redenen).
   3. TEKSTEN     → knoppen, meldingen en labels.

   Tips
   - Volgorde van knoppen = volgorde in de lijst.
   - Product toevoegen: nieuw blok onder `products`, daarna in de flow
     naar de sleutel verwijzen (bijv. product: 'lionsMane').
   - Product verwijderen: haal het weg uit `products` én uit de flow.
     Open de browserconsole (F12): de tool waarschuwt bij fouten.
   - Teksten mogen eenvoudige HTML bevatten (<strong>, <br>).
   ===================================================================== */

window.MushroomFinderConfig = {
 
  avatar: '🍄',
  startNode: 'goal',
 
  /* ---------- Categorieën (kleur + label van het badge) ---------- */
  categories: {
    MIND:    { label: 'MIND',          tone: 'mind' },
    BODY:    { label: 'BODY',          tone: 'body' },
    TOTAL:   { label: 'TOTAL',         tone: 'total' },
    TRUFFEL: { label: 'Magic Truffels', tone: 'truffle' },
    MICRO:   { label: 'Microdosing',   tone: 'micro' }
  },
 
  /* ---------- 1. PRODUCTEN ---------- */
  products: {
    /* Functioneel · McMyco
       forms: per vorm de Shopify-handle (capsules / drops / powder).
       Bestaat een vorm niet, dan staat hij er niet in.
       defaultForm: wat we tonen bij "Geen voorkeur". */
    lionsMane: {
      name: "Lion's Mane", category: 'MIND', icon: '🧠',
      forms: {
        capsules: 'lions-mane-extract-capsules-120-stuks',
        drops:    'lion-s-mane-drops-full-spectrum-extract',
        powder:   'lion-s-mane-poeder-200gr'
      },
      defaultForm: 'capsules',
      pitch: "Lion's Mane wordt vooral gekozen door mensen die focus, concentratie en mentale helderheid belangrijk vinden.",
      short: 'Voor focus, concentratie en mentale vitaliteit.'
    },
    brainbooster: {
      name: 'Brainbooster', category: 'MIND', icon: '🧠',
      forms: { capsules: 'brainbooster-capsules' },
      defaultForm: 'capsules',
      pitch: "Brainbooster combineert Lion's Mane met onder andere L-theanine, ginseng en B-vitamines in één capsule.",
      short: "Lion's Mane gecombineerd met o.a. L-theanine en ginseng."
    },
    cordyceps: {
      name: 'Cordyceps', category: 'BODY', icon: '⚡',
      forms: {
        capsules: 'cordyceps-sinesis-capsules-120-stuks',
        drops:    'mcmyco-cordyceps-drops-full-spectrum-extract',
        powder:   'cordyceps-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Cordyceps is dé keuze voor wie een actieve levensstijl heeft en energie en uithoudingsvermogen centraal zet.',
      short: 'Voor energie en uithoudingsvermogen.'
    },
    reishi: {
      name: 'Reishi', category: 'TOTAL', icon: '🧘',
      forms: {
        capsules: 'reishi-capsules-120-stuks',
        drops:    'reishi-extract-drops',
        powder:   'reishi-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Reishi past bij wie rust, balans en duurzame vitaliteit zoekt — een vaste waarde in een rustig dagritme.',
      short: 'Voor rust, balans en duurzame vitaliteit.'
    },
    chaga: {
      name: 'Chaga', category: 'TOTAL', icon: '🛡️',
      forms: {
        capsules: 'chaga-capsules-120-stuks',
        drops:    'chaga-extract-drops-50-ml',
        powder:   'chaga-poeder-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Chaga wordt gekozen voor natuurlijke weerstand, antioxidanten en algemene vitaliteit.',
      short: 'Voor natuurlijke weerstand en antioxidanten.'
    },
    tremella: {
      name: 'Tremella', category: 'BODY', icon: '✨',
      forms: {
        capsules: 'tremella-fuciformis-capsules-120-stuks',
        powder:   'tremella-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Tremella, ook wel de <em>Beauty Mushroom</em>, is de favoriet voor wie huid & beauty wil combineren met dagelijkse ondersteuning.',
      short: 'De Beauty Mushroom: huid & beauty.'
    },
    maitake: {
      name: 'Maitake', category: 'BODY', icon: '💪',
      forms: {
        capsules: 'maitake-capsules-120-stuks',
        powder:   'maitake-poeder-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Maitake past bij wie vooral lichamelijke vitaliteit en weerstand belangrijk vindt.',
      short: 'Voor lichamelijke vitaliteit.'
    },
    shiitake: {
      name: 'Shiitake', category: 'BODY', icon: '🥢',
      forms: {
        capsules: 'shiitake-extract-capsules-120-stuks',
        powder:   'shiitake-poeder-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Shiitake is een klassieker voor dagelijkse lichamelijke ondersteuning en weerstand.',
      short: 'Klassieker voor dagelijkse lichamelijke ondersteuning.'
    },
    agaricus: {
      name: 'Agaricus Blazei', category: 'BODY', icon: '🍄',
      forms: {
        capsules: 'agaricus-blazei-capsules-120-stuks',
        powder:   'agaricus-blazei-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Agaricus Blazei wordt gekozen voor lichamelijke vitaliteit en natuurlijke weerstand.',
      short: 'Voor lichamelijke vitaliteit en weerstand.'
    },
    fantastic5: {
      name: 'Fantastic 5', category: 'TOTAL', icon: '🌿',
      forms: {
        capsules: 'fantastic-5-capsules-120-stuks',
        drops:    'fantastic-5-mushroom-drops',
        powder:   'fantastic-5-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Fantastic 5 combineert vijf functionele paddenstoelen in één blend — ideaal als je meerdere doelen tegelijk wilt ondersteunen.',
      short: 'Vijf paddenstoelen in één blend.'
    },
    essential8: {
      name: 'Essential 8', category: 'TOTAL', icon: '🌿',
      forms: {
        capsules: 'essential-8-capsules-120-stuks',   // alternatief: 'pouch-essential-8-extract-capsules-120-stuks'
        powder:   'essential-8-200-gram'
      },
      defaultForm: 'capsules',
      pitch: 'Essential 8 is onze breedste blend met acht paddenstoelen, voor wie alles in één dagelijks product wil.',
      short: 'Onze breedste blend: acht paddenstoelen.'
    },
 
    /* Magic Truffels · één handle per product */
    mexicana: {
      name: 'Mexicana', category: 'TRUFFEL', icon: '🌈',
      handle: 'mexicana-psilocybe-mexicana-magic-truffels',
      pitch: 'Mexicana wordt vaak gekozen als toegankelijke truffel en staat bekend om een kleurrijk karakter.',
      short: 'Kleurrijk & toegankelijk.'
    },
    philosophersStone: {
      name: "Philosopher's Stone", category: 'TRUFFEL', icon: '🧠',
      handle: 'philosopher-s-stone-psilocybe-tampanensis-magic-truffels',
      pitch: "Philosopher's Stone (Psilocybe Tampanensis) wordt vaak gekozen door mensen die een filosofische, introspectieve ervaring zoeken.",
      short: 'Filosofisch & introspectief.'
    },
    atlantis: {
      name: 'Atlantis', category: 'TRUFFEL', icon: '🌊',
      handle: 'atlantis-psilocybe-atlantis-magic-truffels',
      pitch: 'Atlantis wordt gezien als een veelzijdige truffel voor wie wil ontdekken.',
      short: 'Veelzijdig & ontdekkend.'
    },
    mushrocks: {
      name: 'MushRocks', category: 'TRUFFEL', icon: '🚀',
      handle: 'mushrocks-psilocybe-galindoii-magic-truffels',
      pitch: 'MushRocks (Psilocybe Galindoii) wordt vaak gekozen door mensen die een visuele, kosmische ervaring zoeken.',
      short: 'Visueel & kosmisch.'
    },
    pinkParadise: {
      name: 'Pink Paradise', category: 'TRUFFEL', icon: '💗',
      handle: 'pink-paradise-psilocybe-roseus-magic-truffels',
      pitch: 'Pink Paradise (Psilocybe Roseus) wordt vaak gekozen door mensen die een emotionele, verbindende ervaring zoeken.',
      short: 'Emotioneel & verbindend.'
    },
    dragonsDynamite: {
      name: "Dragon's Dynamite", category: 'TRUFFEL', icon: '🐉',
      handle: 'dragon-s-dynamite-psilocybe-pajateros-magic-truffels',
      pitch: "Dragon's Dynamite (Psilocybe Pajateros) is bedoeld voor ervaren gebruikers die iets intens en krachtigs zoeken.",
      short: 'Intens & krachtig.'
    },
    dutchDragons: {
      name: 'Dutch Dragons', category: 'TRUFFEL', icon: '🐉',
      handle: 'dutch-dragons-psilocybe-naranja-magic-truffels',
      pitch: 'Dutch Dragons (Psilocybe Naranja) is een sterke truffel voor ervaren gebruikers die iets intens zoeken.',
      short: 'Ook sterk en intens, voor ervaren gebruikers.'
    },
    sugaShrooms: {
      name: 'SugaShrooms', category: 'TRUFFEL', icon: '🐉',
      handle: 'sugashrooms-psilocybe-amanitea-magic-truffels',
      pitch: 'SugaShrooms (Psilocybe Amanitea) is gericht op een uitgesproken psychedelische ervaring voor ervaren gebruikers.',
      short: 'Ook uitgesproken, voor ervaren gebruikers.'
    }
  },
 
  /* ---------- 2. FLOW ----------
     type 'question'   → knoppen; per knop `set` (wat onthouden wordt) en `next` (volgende stap)
     type 'result'     → toont state.product (+ state.alt) als aanbevelingskaart
     type 'collection' → toont producten uit een Shopify-collectie
     step/of           → voortgangsindicator "Vraag 2 van 3"
     group             → kopje boven een groep knoppen                       */
  flow: {
 
    goal: {
      step: 1, of: 3,
      question: 'Waar ben je naar op zoek?',
      options: [
        { group: 'Functionele paddenstoelen', icon: '🧠', label: 'Focus & concentratie',        next: 'focus' },
        { group: 'Functionele paddenstoelen', icon: '⚡', label: 'Energie & uithoudingsvermogen', next: 'energy' },
        { group: 'Functionele paddenstoelen', icon: '🛡️', label: 'Weerstand & vitaliteit',       next: 'immune' },
        { group: 'Functionele paddenstoelen', icon: '🧘', label: 'Rust & balans',                next: 'calm' },
        { group: 'Functionele paddenstoelen', icon: '✨', label: 'Huid & beauty',                next: 'beauty' },
        { group: 'Functionele paddenstoelen', icon: '🌿', label: 'Brede dagelijkse ondersteuning', next: 'broad' }
      ]
    },
 
    focus: {
      step: 2, of: 3,
      question: 'Wat is voor jou het belangrijkste?',
      options: [
        { icon: '🎯', label: 'Focus tijdens werk of studie', next: 'form',
          set: { product: 'lionsMane', reasons: ['Focus & concentratie', 'Mentale helderheid'],
                 alt: 'fantastic5', altWhy: 'Interessant als je naast focus ook energie en algemene vitaliteit wilt ondersteunen.' } },
        { icon: '🧠', label: 'Mentale vitaliteit op lange termijn', next: 'form',
          set: { product: 'lionsMane', reasons: ['Mentale vitaliteit', 'Cognitieve ondersteuning'],
                 alt: 'brainbooster', altWhy: "Lion's Mane gecombineerd met o.a. L-theanine en ginseng, in capsulevorm." } },
        { icon: '⚡', label: 'Focus + energie', next: 'form',
          set: { product: 'fantastic5', reasons: ['Focus én energie', 'Meerdere doelen in één blend'],
                 alt: 'lionsMane', altWhy: 'Kies je toch vooral voor focus? Dan is Lion’s Mane de specialist.' } },
        { icon: '🌿', label: 'Focus + algemene vitaliteit', next: 'form',
          set: { product: 'essential8', reasons: ['Focus én algemene vitaliteit', 'Brede dagelijkse ondersteuning'],
                 alt: 'lionsMane', altWhy: 'Kies je toch vooral voor focus? Dan is Lion’s Mane de specialist.' } }
      ]
    },
 
    energy: {
      step: 2, of: 3,
      question: 'Wat is voor jou het belangrijkste?',
      options: [
        { icon: '⚡', label: 'Meer dagelijkse energie', next: 'form',
          set: { product: 'cordyceps', reasons: ['Dagelijkse energie', 'Lichamelijke vitaliteit'],
                 alt: 'fantastic5', altWhy: 'Interessant als je naast energie ook focus en weerstand wilt ondersteunen.' } },
        { icon: '🏃', label: 'Actieve levensstijl & uithoudingsvermogen', next: 'form',
          set: { product: 'cordyceps', reasons: ['Uithoudingsvermogen', 'Past bij een actieve levensstijl'],
                 alt: 'maitake', altWhy: 'Interessant als je ook lichamelijke vitaliteit belangrijk vindt.' } },
        { icon: '🛡️', label: 'Energie + weerstand', next: 'form',
          set: { product: 'fantastic5', reasons: ['Energie én weerstand', 'Meerdere doelen in één blend'],
                 alt: 'cordyceps', altWhy: 'Gaat het je vooral om energie? Dan is Cordyceps de specialist.' } },
        { icon: '🌿', label: 'Algemene vitaliteit', next: 'form',
          set: { product: 'essential8', reasons: ['Algemene vitaliteit', 'Brede dagelijkse ondersteuning'],
                 alt: 'cordyceps', altWhy: 'Gaat het je vooral om energie? Dan is Cordyceps de specialist.' } }
      ]
    },
 
    immune: {
      step: 2, of: 3,
      question: 'Wat is voor jou het belangrijkste?',
      options: [
        { icon: '🛡️', label: 'Natuurlijke weerstand', next: 'form',
          set: { product: 'chaga', reasons: ['Natuurlijke weerstand', 'Algemene vitaliteit'],
                 alt: 'reishi', altWhy: 'Interessant als je ook rust en balans zoekt.' } },
        { icon: '🫐', label: 'Antioxidanten', next: 'form',
          set: { product: 'chaga', reasons: ['Antioxidanten', 'Natuurlijke weerstand'],
                 alt: 'tremella', altWhy: 'Interessant als je ook huid & beauty belangrijk vindt.' } },
        { icon: '💪', label: 'Lichamelijke vitaliteit', next: 'form',
          set: { product: 'maitake', reasons: ['Lichamelijke vitaliteit', 'Weerstand'],
                 alt: 'agaricus', altWhy: 'Ook gekozen voor lichamelijke vitaliteit en weerstand.' } },
        { icon: '🥢', label: 'Dagelijkse lichamelijke ondersteuning', next: 'form',
          set: { product: 'shiitake', reasons: ['Dagelijkse ondersteuning', 'Weerstand'],
                 alt: 'agaricus', altWhy: 'Ook gekozen voor lichamelijke vitaliteit en weerstand.' } },
        { icon: '🌿', label: 'Weerstand + algemene vitaliteit', next: 'form',
          set: { product: 'essential8', reasons: ['Weerstand én vitaliteit', 'Brede dagelijkse ondersteuning'],
                 alt: 'chaga', altWhy: 'Gaat het je vooral om weerstand? Dan is Chaga de specialist.' } }
      ]
    },
 
    calm: {
      step: 2, of: 3,
      question: 'Wat is voor jou het belangrijkste?',
      options: [
        { icon: '🧘', label: 'Meer rust in mijn dag', next: 'form',
          set: { product: 'reishi', reasons: ['Rust', 'Balans'],
                 alt: 'essential8', altWhy: 'Interessant als je meerdere doelen tegelijk wilt ondersteunen.' } },
        { icon: '⚖️', label: 'Balans & duurzame vitaliteit', next: 'form',
          set: { product: 'reishi', reasons: ['Balans', 'Duurzame vitaliteit'],
                 alt: 'chaga', altWhy: 'Interessant als je ook natuurlijke weerstand belangrijk vindt.' } },
        { icon: '🌙', label: 'Een rustig avondritueel', next: 'form',
          set: { product: 'reishi', reasons: ['Rust', 'Past in een avondritueel'],
                 alt: 'tremella', altWhy: 'Interessant als je ook huid & beauty belangrijk vindt.' } },
        { icon: '🌿', label: 'Rust + weerstand', next: 'form',
          set: { product: 'essential8', reasons: ['Balans én weerstand', 'Brede dagelijkse ondersteuning'],
                 alt: 'reishi', altWhy: 'Gaat het je vooral om rust en balans? Dan is Reishi de specialist.' } }
      ]
    },
 
    beauty: {
      step: 2, of: 3,
      question: 'Wat is voor jou het belangrijkste?',
      options: [
        { icon: '✨', label: 'Huid & beauty', next: 'form',
          set: { product: 'tremella', reasons: ['Huid & beauty', 'De Beauty Mushroom'],
                 alt: 'chaga', altWhy: 'Interessant als je ook antioxidanten en weerstand belangrijk vindt.' } },
        { icon: '💧', label: 'Glow van binnenuit', next: 'form',
          set: { product: 'tremella', reasons: ['Huid & beauty', 'Dagelijks beautyritueel'],
                 alt: 'reishi', altWhy: 'Interessant als je ook rust en balans zoekt.' } },
        { icon: '🛡️', label: 'Beauty + weerstand', next: 'form',
          set: { product: 'tremella', reasons: ['Huid & beauty', 'Gecombineerd met algemene ondersteuning'],
                 alt: 'essential8', altWhy: 'Interessant als je meerdere doelen tegelijk wilt ondersteunen.' } },
        { icon: '🌿', label: 'Beauty + algemene vitaliteit', next: 'form',
          set: { product: 'essential8', reasons: ['Beauty én vitaliteit', 'Brede dagelijkse ondersteuning'],
                 alt: 'tremella', altWhy: 'Gaat het je vooral om huid & beauty? Dan is Tremella de specialist.' } }
      ]
    },
 
    broad: {
      step: 2, of: 3,
      question: 'Wat past het best bij jou?',
      options: [
        { icon: '🌿', label: 'Eén product voor alles', next: 'form',
          set: { product: 'essential8', reasons: ['Brede dagelijkse ondersteuning', 'Acht paddenstoelen in één'],
                 alt: 'fantastic5', altWhy: 'Compactere blend met vijf paddenstoelen.' } },
        { icon: '⚡', label: 'Vooral focus + energie', next: 'form',
          set: { product: 'fantastic5', reasons: ['Focus én energie', 'Meerdere doelen in één blend'],
                 alt: 'essential8', altWhy: 'Nog breder: acht paddenstoelen in één blend.' } },
        { icon: '🛡️', label: 'Vooral weerstand + vitaliteit', next: 'form',
          set: { product: 'essential8', reasons: ['Weerstand én vitaliteit', 'Brede dagelijkse ondersteuning'],
                 alt: 'chaga', altWhy: 'Gaat het je vooral om weerstand? Dan is Chaga de specialist.' } },
        { icon: '🤷', label: 'Weet ik nog niet', next: 'form',
          set: { product: 'fantastic5', reasons: ['Brede ondersteuning', 'Goede eerste kennismaking'],
                 alt: 'essential8', altWhy: 'Nog breder: acht paddenstoelen in één blend.' } }
      ]
    },
 
    form: {
      step: 3, of: 3,
      question: 'Welke vorm heeft je voorkeur?',
      options: [
        { icon: '💊', label: 'Capsules',      hint: 'Makkelijk mee te nemen',          set: { form: 'capsules' }, next: 'result' },
        { icon: '💧', label: 'Drops',         hint: 'Snel en flexibel',                set: { form: 'drops' },    next: 'result' },
        { icon: '🥄', label: 'Poeder',        hint: 'In koffie, thee of smoothie',     set: { form: 'powder' },   next: 'result' },
        { icon: '🤷', label: 'Geen voorkeur', hint: 'Wij kiezen de best passende vorm', set: { form: 'none' },     next: 'result' }
      ]
    },
 
    result: { type: 'result', label: 'Jouw match' },
 
    /* ---- Aparte route: Magic Truffels ---- */
    psyType: {
      step: 2, of: 2,
      intro: { tone: 'truffle', title: '🌈 Je zoekt een psychedelische ervaring',
               text: 'Magic Truffels bevatten van nature psilocybine en zijn iets heel anders dan onze functionele McMyco-paddenstoelen. Alleen voor 18+.' },
      question: 'Welk soort ervaring spreekt je aan?',
      options: [
        { icon: '🌈', label: 'Kleurrijk & toegankelijk', next: 'psyResult',
          set: { product: 'mexicana', reasons: ['Je koos: kleurrijk & toegankelijk'], alt: null, altWhy: null } },
        { icon: '🧠', label: 'Filosofisch & introspectief', next: 'psyResult',
          set: { product: 'philosophersStone', reasons: ['Je koos: filosofisch & introspectief'], alt: null, altWhy: null } },
        { icon: '🌊', label: 'Veelzijdig & ontdekkend', next: 'psyResult',
          set: { product: 'atlantis', reasons: ['Je koos: veelzijdig & ontdekkend'], alt: null, altWhy: null } },
        { icon: '🚀', label: 'Visueel & kosmisch', next: 'psyResult',
          set: { product: 'mushrocks', reasons: ['Je koos: visueel & kosmisch'], alt: null, altWhy: null } },
        { icon: '💗', label: 'Emotioneel & verbindend', next: 'psyResult',
          set: { product: 'pinkParadise', reasons: ['Je koos: emotioneel & verbindend'], alt: null, altWhy: null } },
        { icon: '🐉', label: 'Intens & krachtig', hint: 'Voor ervaren gebruikers', next: 'psyResult',
          set: { product: 'dragonsDynamite', reasons: ['Je koos: intens & krachtig'], alt: ['dutchDragons', 'sugaShrooms'], altWhy: null } }   // eerste die op voorraad is
      ]
    },
 
    psyResult: { type: 'result', label: 'Jouw match', notice: 'psychedelic' },
 
    /* ---- Aparte route: Microdosing ---- */
    micro: {
      type: 'collection', label: 'Microdosing',
      /* Vaste lijst producten (Shopify-handles). Liever een collectie?
         Vervang `handles` door: collection: 'handle-van-je-collectie' */
      handles: [
        'mcmicrodose-starterkit-mexicana-truffels',
        'mcmicrodose-truffelmixture',
        'microdose-synergy-capsules-60-stuks'
      ],
      title: '🔬 Onze microdose-producten',
      intro: { tone: 'micro', title: 'Microdosing is een eigen categorie',
               text: 'Microdose-producten zijn iets anders dan onze functionele paddenstoelen én dan een volledige psychedelische ervaring.' },
      notice: 'microdose'
    }
  },
 
  /* ---------- Meldingen ---------- */
  notices: {
    psychedelic: { tone: 'warn', title: 'Goed om te weten',
      text: 'Effecten zijn persoonlijk en onvoorspelbaar. Deze omschrijving is een productpositionering, geen garantie. Lees vóór gebruik altijd de productinformatie en waarschuwingen. Alleen voor 18+.' },
    microdose: { tone: 'warn', title: 'Geen doseeradvies',
      text: 'We geven geen persoonlijk doseeradvies. Lees voor gebruik en waarschuwingen altijd de officiële productinformatie. Alleen voor 18+.' }
  },
 
  /* ---------- 3. TEKSTEN ---------- */
  intro: {
    icon: '🍄',
    title: 'Vind jouw paddenstoel in 30 seconden',
    text: 'Maximaal drie korte vragen, alleen klikken. Daarna zie je direct welk product het best bij je past.',
    pills: [
      { label: 'MIND', tone: 'mind' },
      { label: 'BODY', tone: 'body' },
      { label: 'TOTAL', tone: 'total' }
    ]
  },
 
  text: {
    start: 'Start de keuzehulp →',
    back: 'Terug',
    restart: 'Opnieuw',
    progress: 'Vraag {n} van {t}',
    loading: 'Jouw match wordt gezocht…',
    matchPrefix: 'Jouw match:',
    categoryPrefix: 'Categorie',
    whyTitle: 'Waarom deze bij jou past',
    formMatch: 'Past bij je gekozen productvorm',
    formFallback: 'Niet als {wanted} verkrijgbaar — we tonen de {shown}.',
    view: 'Bekijk {name} →',
    altPrefix: 'Alternatief:',
    soldOut: 'Tijdelijk uitverkocht',
    from: 'vanaf',
    emptyCollection: 'De producten konden niet geladen worden.',
    forms: { capsules: 'capsules', drops: 'drops', powder: 'poeder' }
  }
};